module.exports = __webpack_public_path__ + "img/md5-normal1.01c719ba.png";